import React from 'react';
import Button from '@material-ui/core/Button';

import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

const style = theme => ({
    progress: {
        position: 'relative'
    },
    overlay: {
        position: 'fixed',
        display: 'block',
        width: '100%',
        height: '100%',
        top: '0',
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: '2'
    },
    text: {
        fontSize: '50px',
        color: 'white'
    },
    // container: {
    //     position: 'absolute',
    //     top: '50%',
    //     left: '50%',
    //     transform: 'translate(-50%,-50%)'
    // }
});

const Loader = props => {

    const { loadingText, classes } = props;

    const loader = (
        <Grid
            style={{
                position: 'absolute',
                top: '40%'
            }}
            container
            direction="row"
            justify="center"
            alignItems="center">
            <Grid item>
                <CircularProgress className={classes.progress} size={100} />
            </Grid>
            <Grid item xs={12}>
                <Typography className={classes.text} variant="display1" align="center" gutterBottom>
                    {loadingText ? loadingText : "loading..."}
                </Typography>
            </Grid>
        </Grid>
    );

    const retry = (
        <div className={classes.container}>
            <span
                className={classes.text}>
                There seems to have been an issue loading the content. Please click retry below
            </span>
            <Button
                variant="contained"
                color="primary"
                onClick={props.retry}>
                Retry
            </Button>
        </div>
    );

    return (
        <div className={classes.overlay}>
            <Grid container>
                {props.timeout ? retry : null}
                {props.isLoading ? loader : null}
            </Grid>
        </div>
    );
};

Loader.propTypes = {
    loadingText: PropTypes.string
};

export default withStyles(style)(Loader);



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js